import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Logo } from '@/components/ui/Logo';
import { FiArrowLeft } from 'react-icons/fi';

export function AuthLayout() {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50">
      <div className="flex flex-col justify-center px-4 py-12 sm:px-6 lg:px-8 xl:px-24">
        <div className="mx-auto w-full max-w-sm">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-slate-500 hover:text-slate-900 mb-8 transition-colors">
            <FiArrowLeft className="w-4 h-4 mr-2" /> Back to home
          </Link>
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4 }}
          >
            <Logo className="mb-8" />
            <Outlet />
          </motion.div>
        </div>
      </div>
      <div className="hidden lg:block relative w-full h-full bg-slate-900 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-900 via-slate-900 to-accent-900 opacity-90" />
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1558981806-ec527fa84c39?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center mix-blend-overlay opacity-30" />
        <div className="relative h-full flex flex-col items-center justify-center text-white p-12 text-center">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="max-w-lg"
          >
            <h2 className="text-4xl font-bold mb-6">Turn Miles Into Marketing</h2>
            <p className="text-lg text-slate-300 leading-relaxed">
              Join the premier marketplace connecting businesses with everyday drivers. 
              Transform your commute into earnings or get your brand moving across the city.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}